<template>
  <vs-popup class="buy-me-claim" title="" :active.sync="popupActive">
    <BuyMeClaim/>
  </vs-popup>
</template>

<script>
import BuyMeClaim from './BuyMeClaim'

export default {
  props: {
  },
  components: {
    BuyMeClaim
  },
  data () {
    return {
      popupActive: false
    }
  },
  computed: {

  },
  methods: {
    show () {
      this.$store.dispatch('ADDITIONAL_USER_INFO', { buyMePopupOpen: true })
      this.popupActive = true
    },
  }
}
</script>

<style land="scss">
@media screen and (min-width: 900px) {
  .buy-me-claim .vs-popup {
    width: 80% !important;
  }
}


</style>
